import type { PlcManufacturerCodeLibrary } from "./types";

export const br_automationCodeLibrary: PlcManufacturerCodeLibrary = {
  manufacturer_id: "br-automation",
  manufacturer_name: "B&R Industrial Automation",
  codes: [
    {
      id: "br-x20bc-ram-error",
      manufacturer_id: "br-automation",
      series_id: "br-x20-plc",
      model: null,
      code: "S/E BLINK: RAM ERROR",
      code_type: "LED/System Stop",
      title_ar: "B&R X20 RAM error",
      description_ar: "بـX20BC0083، S/E LED يومض بنمط محدد ليدل على RAM error.",
      symptoms: ["S/E يومض أحمر بنمط RAM error", "الجهاز ما يشتغل طبيعي"],
      causes: ["RAM error داخلي والجهاز متضرر"],
      checks: [
        {
          step: 1,
          action: "طابق نمط وميض S/E مع جدول الداتا شيت.",
          expected: "ماكو error blink.",
          faulty: "النمط يطابق RAM error.",
        }
      ],
      solutions: ["الدليل يحدد استبدال الجهاز عند RAM error."],
      severity: "حرجة",
      source_title: "B&R X20(c)BC0083 Data Sheet",
      source_section: "S/E blinking error code: RAM error",
      keywords: ["B&R", "X20", "RAM error", "S/E"],
    },
    {
      id: "br-x20bc-hardware-error",
      manufacturer_id: "br-automation",
      series_id: "br-x20-plc",
      model: null,
      code: "S/E BLINK: HARDWARE ERROR",
      code_type: "LED/System Stop",
      title_ar: "B&R X20 Hardware error",
      description_ar: "نمط S/E المحدد يدل على Hardware error بالجهاز أو system component.",
      symptoms: ["S/E يومض أحمر بنمط Hardware error"],
      causes: ["الجهاز أو مكوّن بالنظام متضرر"],
      checks: [
        {
          step: 1,
          action: "طابق blink code قبل فك أي موديول.",
          expected: "ماكو hardware error pattern.",
          faulty: "النمط يطابق Hardware error.",
        }
      ],
      solutions: ["استبدل الجزء المتضرر حسب تشخيص B&R والداتا شيت."],
      severity: "حرجة",
      source_title: "B&R X20(c)BC0083 Data Sheet",
      source_section: "S/E blinking error code: Hardware error",
      keywords: ["B&R", "X20", "hardware error"],
    },
    {
      id: "br-x20cp-system-stop",
      manufacturer_id: "br-automation",
      series_id: "br-x20-plc",
      model: null,
      code: "RED BLINK: SYSTEM STOP",
      code_type: "System Stop LED",
      title_ar: "B&R X20 System Stop",
      description_ar: "داتا شيت X20CP1483 توضح أن red blinking LED ممكن يدل على System Stop ويعرض error code.",
      symptoms: ["CPU ما يدخل RUN", "Red LED يومض"],
      causes: ["System stop بسبب خطأ runtime/hardware/configuration"],
      checks: [
        {
          step: 1,
          action: "سجل blink/error information من Automation Studio/System Diagnostics Manager.",
          expected: "سبب System Stop يكون ظاهر.",
          faulty: "يستمر red blinking بدون معالجة.",
        }
      ],
      solutions: ["اقرأ الـlogger/system dump قبل Reset.", "عالج السبب المحدد بالـruntime diagnostics."],
      severity: "حرجة",
      source_title: "B&R X20CP1483 Data Sheet",
      source_section: "System stop: red blinking LED indicates error code",
      keywords: ["B&R", "X20CP", "system stop", "red LED"],
    },
    {
      id: "br-x20-plk-manager-failed",
      manufacturer_id: "br-automation",
      series_id: "br-x20-plc",
      model: null,
      code: "POWERLINK MN FAILED",
      code_type: "POWERLINK LED",
      title_ar: "POWERLINK managing node failed",
      description_ar: "بحالة Controlled Node المحددة، نمط LED الموثق يعني أن POWERLINK managing node فشل.",
      symptoms: ["POWERLINK ما يدخل Operational", "LEDs تبين managing node failure"],
      causes: ["Managing Node مو متوفر", "POWERLINK cable/network/configuration issue"],
      checks: [
        {
          step: 1,
          action: "افحص managing node والشبكة والعناوين.",
          expected: "Managing node موجود والشبكة تدخل التشغيل.",
          faulty: "CN يبقى يبين MN failed.",
        }
      ],
      solutions: ["افحص POWERLINK topology والتغذية والعقد.", "راجع node number وإعداد network."],
      severity: "عالية",
      source_title: "B&R X20CP1483 Data Sheet",
      source_section: "POWERLINK managing node failed LED state",
      keywords: ["B&R", "POWERLINK", "managing node"],
    },
  ],
};
